<template>
    <span>
        <router-link
            v-if="showDistribute"
            :to="`/${organizationSlug}/configuration-sets/${row['id']}/distributions/create`"
            class="action icon-send"
            title="Send"
            :data-test-id="`row-${row.id}-action-distribute`"
        />
        <router-link
            v-if="showDistribute"
            :to="`/${organizationSlug}/configuration-sets/${row['id']}/distributions`"
            class="action icon-view"
            title="View"
            :data-test-id="`row-${row.id}-action-view`"
        />
        <router-link
            v-if="showEdit"
            :to="`/${organizationSlug}/configuration-sets/${row['id']}/edit`"
            class="action icon-edit"
            title="Edit"
            :data-test-id="`row-${row.id}-action-edit`"
        />
        <a
            v-if="showDelete"
            :data-test-id="`row-${row.id}-action-delete`"
            class="delete icon-delete"
            href="#"
            title="Delete"
            @click.prevent="deleteConfigurationSet()"
        />
    </span>
</template>

<script>
import canConfirm from '@/mixins/canConfirm'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'
import canToast from '@/mixins/canToast'

export default {
    components: {},

    mixins: [canConfirm, needsOrganizationSlug, canToast],

    props: {
        row: {
            type: Object,
            required: true,
        },
    },

    emits: ['reload'],

    data() {
        const { hasPermission } = this.$store.getters
        const showDistribute = hasPermission('create configuration sets')
        const showDelete = hasPermission('delete configuration sets') && !this.row.is_distributed
        const showEdit = hasPermission('update configuration sets') && !this.row.is_distributed

        return {
            showDistribute,
            showEdit,
            showDelete,
        }
    },

    methods: {
        deleteConfigurationSet() {
            this.confirmDelete().then((willDelete) => {
                if (willDelete === true) {
                    this.$http
                        .delete(`${this.organizationSlug}/configuration-sets/${this.row.id}`)
                        .then(() => {
                            this.toast(`Configuration Set successfully deleted!`)
                            this.$emit('reload')
                        })
                        .catch((error) => {
                            this.toast(`Could not delete Configuration Set`, 'error')
                        })
                }
            })
        },
        confirmDelete() {
            return this.confirm({
                message: 'Are you sure you want to delete this Configuration Set?',
                acceptLabel: 'Delete',
                danger: true,
            })
        },
    },
}
</script>
